import axios from "axios";
import { toast } from "react-toastify";
import store from "store";
import { getUserType } from "pages/Utility/localStorageUtil";

axios.defaults.headers.common["Content-Type"] = "application/json";
axios.defaults.headers.common["Accept"] = "application/json";

const showErrorToast = (message) => {
	if (message) toast.error(String(message).replaceAll("_", " "));
};

axios.interceptors.response.use(
	// ── Success (HTTP 2xx) ───────────────────────────────────────────────────
	(response) => {
		const body = response?.data;
		// Some endpoints return HTTP 200 with an error status in the body
		if (body?.status && body.status >= 400 && body?.message) {
			showErrorToast(body.message);
		}
		return response;
	},

	// ── Error (HTTP 4xx / 5xx / network) ────────────────────────────────────
	async (error) => {
		if (!error?.response) {
			if (error?.code !== "ERR_CANCELED") {
				toast.error("Network error. Please check your connection.");
			}
			return Promise.reject(error);
		}

		const { response } = error;
		const type = getUserType();
		const message = response?.data?.message;

		if (
			(message === "not_authorized_old_Token" ||
				message === "not_authorized" ||
				message === "Admins_only") &&
			!window.location?.pathname?.includes("/forget-password")
		) {
			const AuthService = await import("./Website/AuthService");
			AuthService.logout();
			window.location = type === "admin" ? `/admin/login` : "/login";
			return;
		}

		showErrorToast(message);
		return Promise.reject(error);
	},
);

function setJwt(jwt) {
	axios.defaults.headers.common["Authorization"] = `${jwt}`;
}

function setLang(lang) {
	if (!lang) {
		const state = store.getState();
		lang = state?.Auth?.lang?.length ? state.Auth.lang : "en";
	}
	axios.defaults.headers.common["lang"] = lang;
}

export default {
	get: axios.get,
	post: axios.post,
	put: axios.put,
	delete: axios.delete,
	setJwt,
	setLang,
};
